import { render, staticRenderFns } from "./SettingsTimezoneSelect.vue?vue&type=template&id=45e5266c&"
import script from "./SettingsTimezoneSelect.vue?vue&type=script&lang=js&"
export * from "./SettingsTimezoneSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e5266c')) {
      api.createRecord('45e5266c', component.options)
    } else {
      api.reload('45e5266c', component.options)
    }
    module.hot.accept("./SettingsTimezoneSelect.vue?vue&type=template&id=45e5266c&", function () {
      api.rerender('45e5266c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/Settings/SettingsTimezoneSelect.vue"
export default component.exports